import { useEffect, useState } from 'react'
import { loadLimits } from '../api/limits.js'
import { DEFAULT_EXCLUSION_NOTE } from '../components/common/text.js'

export function useExclusionNoteLimit() {
  const [max, setMax] = useState(DEFAULT_EXCLUSION_NOTE)
  useEffect(() => {
    let live = true
    loadLimits()
      .then(l => {
        if (live && l?.exclusionNoteLength) setMax(l.exclusionNoteLength)
      })
      .catch(() => {})
    return () => {
      live = false
    }
  }, [])
  return max
}
